import React from 'react'
import './PaymentPage.scss'
import '../../utils/Styles/globalclasses.scss'

import Footer from '../../components/footer/Footer'
import PaymentBody from './components/PaymentBody/PaymentBody'
import { useLocation, useHistory } from 'react-router'

const PaymentPage = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  })



  const history = useHistory()
  const { pathname, state } = useLocation()
  let pageType
  pathname.includes('customize') ? (pageType = 'customize') : (pageType = 'payment')
  if (state?.type === undefined) {
    history.push('/price-plan')
  }
  return (
    <div>
      <PaymentBody pageType={pageType} state={state} />
      <Footer />
    </div>
  )
}

export default PaymentPage
